import { render, staticRenderFns } from "./PodcastEmbed.vue?vue&type=template&id=6cf077e6&scoped=true"
import script from "./PodcastEmbed.vue?vue&type=script&lang=ts"
export * from "./PodcastEmbed.vue?vue&type=script&lang=ts"
import style0 from "./PodcastEmbed.vue?vue&type=style&index=0&id=6cf077e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf077e6",
  null
  
)

export default component.exports